(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-country-popup"]) return;
  try {
    
  (() => {
    const initialize = () => {
      const root = document.getElementById('ClesanaDeliveryCountry');
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      const trigger = root.querySelector('.clesana-country-trigger');
      const close = root.querySelector('.clesana-country-close');
      const form = root.querySelector('form');
      const select = root.querySelector('select');
      const submit = root.querySelector('.clesana-country-submit');
      const error = root.querySelector('.clesana-country-error');
      const key = `clesana_delivery_country_v1_${root.dataset.theme}`;
      const pendingKey = `${key}_pending`;
      const read = (name) => {
        try { return JSON.parse(localStorage.getItem(name)); } catch { return null; }
      };
      const write = (name, value) => {
        try { localStorage.setItem(name, JSON.stringify(value)); } catch {}
      };
      const remove = (name) => {
        try { localStorage.removeItem(name); } catch {}
      };
      const supportedCountries = new Set(Array.from(select.options, (option) => option.value));
      const valid = (value) => value && value.expires > Date.now() && supportedCountries.has(value.country);
      const pending = read(pendingKey);
      if (valid(pending) && pending.country === root.dataset.country) {
        write(key, pending);
        remove(pendingKey);
      } else if (pending) {
        remove(pendingKey);
        error.hidden = false;
      }
      const preference = read(key);
      const confirmed = valid(preference) && preference.country === root.dataset.country;
      const designMode = root.dataset.designMode === 'true';
      const placeTrigger = () => {
        const icons = document.querySelector('#SiteHeader .site-nav__icons');
        if (icons && trigger.parentElement !== icons) {
          icons.prepend(trigger);
          icons.closest('.header-item--icons')?.classList.add('clesana-country-header');
        }
      };
      placeTrigger();
      document.addEventListener('shopify:section:load', placeTrigger);
      const open = () => {
        if (dialog.open) return;
        close.hidden = !confirmed && !designMode;
        dialog.showModal();
      };
      trigger.addEventListener('click', open);
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('cancel', (event) => {
        if (!confirmed && !designMode) event.preventDefault();
      });
      dialog.addEventListener('close', () => trigger.focus());
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
        write(pendingKey, { country: select.value, expires: Date.now() + 30 * 24 * 60 * 60 * 1000 });
        submit.disabled = true;
        submit.textContent = submit.dataset.loading;
      });
      window.addEventListener('pageshow', () => {
        submit.disabled = false;
        submit.textContent = submit.dataset.label || submit.textContent;
      });
      submit.dataset.label = submit.textContent;
      if (!confirmed && !designMode) open();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
